import React, { useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'
import { toast } from 'react-toastify'
import { CREATE, useClient } from '@peracto/client'
import { Heading, ServerErrorMessage } from '@peracto/peracto-ui'

import CategoryForm from './CategoryForm'
import useCategories from './useCategories'
import { asTree } from './categoryTree'
import { categoryForApi, categorySchema } from './categoryFields'
import { showApiError } from './apiErrors'

const CategoryAdd = () => {
    const { client } = useClient()
    const { categories, error } = useCategories()
    const [redirect, setRedirect] = useState('')

    const onSubmit = async (values, actions) => {
        try {
            const response = await client(CREATE, 'vehicle-categories', { data: categoryForApi(values) })
            toast.success('Category added. Now add its GenArts.')
            actions.setSubmitting(false)
            setRedirect(response.data['@id'])
        } catch (e) {
            showApiError(e, actions)
        }
    }

    if (error) {
        return <ServerErrorMessage />
    }

    if (redirect) {
        return <Redirect to={redirect} />
    }

    return (
        <>
            <Helmet>
                <title>Vehicle Categories | Add | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Add Vehicle Category">
                    <div className="flex-grow-1 d-flex align-items-center justify-content-end">
                        <Link className="btn btn-outline-primary" to="/vehicle-categories">
                            <FontAwesomeIcon icon={faArrowCircleLeft} className="mr-2" />
                            Back to Vehicle Categories
                        </Link>
                    </div>
                </Heading>
                {categories === null ? (
                    <div className="card">
                        <div className="card-body">Loading...</div>
                    </div>
                ) : (
                    <CategoryForm tree={asTree(categories)} onSubmit={onSubmit} schema={categorySchema} />
                )}
            </div>
        </>
    )
}

export default CategoryAdd
